import '@babel/polyfill';
import { createHooks } from '@wordpress/hooks';
import Tippy from 'tippy.js';
import Panzoom from '@panzoom/panzoom';
import Favorites from './favorites';
import './jquery-functions';
import Helper from './helper';

window.wphooks = createHooks();

/**
 * @global settings Settings passed by WordPress
 */
class Areas {
  /**
   * Set properties
   */
  constructor() {
    const passedSettings = Helper.filterObjectValues(settings);
    
    this.popups = [];
    this.lotSelector = document.querySelector('.lot-selector');
    this.areaSelector = $('.lot-selector-area');
    this.popupSelector = $('[data-lot-popup]');
    this.filters = $('.lot-selector-filter');
    this.filterables = $('.lot-selector-filterable');
    this.filterForm = $('.lot-selector-filter-form');
    this.settings = {
      breakpoint: 768,
      limit_favorites: false,
      enable_panzoom: false,
      ...passedSettings,
    };
  }

  /**
   * Initialize all needed actions
   */
  init() {
    Areas.setPolyfills();
    this.setPopups();
    Areas.setPointClick();
    Areas.registrationTabs();
    this.setPanzoom();
    
    /**
     * Trigger form submit on filter
     * 
     * @listens change
     */
    this.filters.on('change', (e) => {
      $(e.currentTarget).parents('form').trigger('submit');
    });

    /**
     * Handle filter form submission
     * 
     * @listens submit
     */
    this.filterForm.on('submit', e => this.handleFilter(e));


    /**
     * Open registration pop-up
     * 
     * @listens click
     */
    $(document).on('click', '[data-popup-target]', (e) => {
      if ($(window).width() < this.settings.breakpoint && $(e.currentTarget).hasClass('lot-item')) {
        return;
      }
  
      e.preventDefault();
      const popup = $($(e.currentTarget).data('popup-target'));
      Areas.togglePopup(popup);
    });

    /**
     * Close popup when Esc is pressed
     */
    $(document).on('keyup', (e) => {
      if (e.key === 'Esc' || e.key === 'Escape') {
        const openPopup = $('.popup-wrap.open');

        if (openPopup.length) {
          Areas.togglePopup(openPopup);
        }
      }
    });

    /**
     * Set favorites
     */
    this.favorites = new Favorites(this.settings.post_type, this.settings.limit_favorites);
  }

  static togglePopup(popupTarget) {
    const popup = popupTarget;

    if (!popup) {
      return;
    }

    popup.toggleClass('open');
  }

  handleFilter(e) {
    e.preventDefault();
    
    const filters = $(e.currentTarget).serializeObject();
    
    this.filterAreas(filters);
  }

  filterAreas(filters) {
    this.filterables.attr('data-filter-match', 'false');

    const filteredAreas = this.filterables.filter(function matchValues() {
      let match = true;

      Object.entries(filters).forEach((filter) => {
        const [name, filterObject] = filter;
        const type = filterObject[0];
        const operator = filterObject[1];
        const filterValue = filterObject[2];

        if (filterValue === '*') return;

        const filterName = name.replace('lot-selector-', '');
        const itemValue = $(this).data(filterName);
        
        if (
          typeof itemValue === 'undefined'
          || !Areas.filterEvaluation(itemValue, filterValue, operator, type)
        ) {
          match = false;
        }
      });

      return match;
    });
    
    filteredAreas.attr('data-filter-match', 'true');
  }

  static setPointClick() {
    if (window.matchMedia('(pointer: fine)').matches) {
      $('.lot-selector-area[data-href]').on('click', function navigateToLink() {
        const url = $(this).data('href');
        window.location = url;
      });
    }
  }

  static setPolyfills() {
    if (!SVGElement.prototype.contains) {
      SVGElement.prototype.contains = HTMLDivElement.prototype.contains;
    }
  }

  /**
   * Loop through each area and set their respective pop-ups
   */
  setPopups() {
    if ($(window).width() > this.settings.breakpoint) {
      if (this.areaSelector.length) {
        const defaultOptions = {
          appendTo: $('.lot-selector-map')[0],
          duration: 0,
          interactive: true,
          offset: [0, 10],
          placement: 'top',
          trigger: 'mouseenter click focus',
          zIndex: 9999,
        };
        
        // Merge default options with options passed by PHP
        const options = Object.assign({}, defaultOptions, this.settings.popup_options);

        this.areaSelector.each((index, area) => {
          const popupTarget = $(area).data('lot-popup-target');
          const popupEl = $(`.lot-selector-popups [data-lot-popup=${popupTarget}]`);
          
          // Set popup content
          [options.content] = popupEl;

          // Create popup
          const popup = new Tippy(area, options);

          // Add popup
          this.popups.push(popup);
        });
      }
    }
  }

  /**
   * Lets user zoom in/out and pan the lot selector view
   */
  setPanzoom() {
    if (!this.settings.enable_panzoom) {
      return;
    }

    const defaultOptions = {
      contain: 'outside',
      minScale: 1,
      startScale: 1,
    };

    // Merge default options with options passed by PHP
    const options = Object.assign({}, defaultOptions, this.settings.panzoom_options);
    
    const panzoomWrap = this.lotSelector.querySelector('.lot-selector-panzoom-wrap');
    const panzoomEl = panzoomWrap.querySelector('.lot-selector-panzoom');
    const zoomInButton = panzoomWrap.querySelector('.zoom-in');
    const zoomOutButton = panzoomWrap.querySelector('.zoom-out');

    const panzoom = Panzoom(panzoomEl, options);

    panzoomEl.parentNode.addEventListener('wheel', panzoom.zoomWithWheel);
    zoomInButton.addEventListener('click', panzoom.zoomIn);
    zoomOutButton.addEventListener('click', panzoom.zoomOut);

    // Rescale buttons on zoom
    panzoomEl.addEventListener('panzoomzoom', (e) => {
      panzoomEl.style.setProperty('--scale', e.detail.scale);
    });

    // Expose Panzoom on the selector
    const panzoomReadyEvent = new Event('panzoomready');
    this.lotSelector.panzoom = panzoom;
    this.lotSelector.dispatchEvent(panzoomReadyEvent);
  }

  static registrationTabs() {
    $('.tab_content_login').hide();
    $('ul.tabs_login li:first a').addClass('active').show();
    $('.tab_content_login:first').show();

    $('a[data-tab]').on('click', function setCurrentTab() {
      $('ul.tabs_login li a').removeClass('active');
      $(this).addClass('active');
      $('.tab_content_login').hide();
      const activeTab = $(this).data('tab');
      
      $(activeTab).show();
    });
  }

  /**
   * Eval passed values with operator
   * 
   * @param {*} itemValue 
   * @param {*} filterValue 
   * @param {*} operator 
   * @param {*} type Return value depends heavily on type, make sure this is the correct type
   * @returns Bool
   */
  static filterEvaluation(itemValue, filterValue, operator = '==', type = 'string') {
    /* eslint-disable no-new-func, no-param-reassign */
    itemValue = type === 'number' ? Areas.numberify(itemValue) : Areas.stringify(itemValue);

    if (operator === 'between' && filterValue.includes(',')) {
      filterValue = JSON.parse(filterValue);
    } else {
      filterValue = type === 'number' ? Areas.numberify(filterValue) : Areas.stringify(filterValue);
    }

    if (typeof filterValue === 'object') {
      filterValue.forEach((objectValue, index) => {
        filterValue[index] = type === 'number' ? Areas.numberify(objectValue) : Areas.stringify(objectValue);
      });
    }

    if (operator === 'between') {
      return itemValue > filterValue[0] && itemValue < filterValue[1];
    }

    return Function(`return (${itemValue} ${operator} ${filterValue})`)();
  }

  static stringify(value) {
    return `"${value}"`;
  }

  /**
   * Makes euro standard number (or price) JavaScript compatible
   * @param {*} value 
   * @returns 
   */
  static numberify(value) {
    let newValue = value;

    if (typeof value === 'string') {
      newValue = newValue.trim();
      
      // Remove all '.', and replace '.' for ','
      newValue = newValue.replace(/\./g, '').replace(',', '.');
    }
    
    return parseInt(newValue, 10);
  }
}

/**
 * Fire when everything is loaded
 */
$(document).ready(() => {
  new Areas().init();
});
